import React, {useEffect, useState } from "react";
import Header from "./Header";
import PreLoader from "./PreLoader";
import Menus from "./Menus";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import { Container } from "reactstrap";

const Layout = (props)=>{

    return(
        <React.Fragment>
            {/* <Header/> */}
            <Menus/>
            <div className="main-content">
                {/* {props.children} */}
                <div className="page-content" style={{marginTop:'10px'}}>
                    <Outlet/>
                </div>
                <Footer/>
            </div>
            <PreLoader/>
        </React.Fragment>
    );
};

export default Layout;